import * as React from "react";

import useBridgeClient from "src/common/hooks/BridgeSWRClient";
import { endpoint } from "src/lib/bridgeClient";

export const useGetScheduler = (schedulerId: number): { data: Scheduler; error: Error } => {
  const { data, error } = useBridgeClient<Scheduler[]>(endpoint.availableSchedulers);

  const { memoData, memoError } = React.useMemo(() => {
    if (error) {
      return { memoData: null, memoError: error };
    }

    if (data && data.length > 0) {
      for (const scheduler of data) {
        if (scheduler.id === schedulerId) {
          return { memoData: scheduler, memoError: null };
        }
      }
    }

    return { memoData: null, memoError: new Error("scheduler not found") };
  }, [data, error, schedulerId]);

  return { data: memoData, error: memoError };
};
